<div class="container-fluid">
  <div class="row">
    <div class="col-xs-1 col-md-3"></div>
    <div class="col-xs-10 col-md-6">
      @if (step=='verify') {
        <div class="mt-3 mb-2">
          <div class="box box-default bg-white">
            <div class="box-header">
              <div class="text-center pt-4 pb-4">
                <span class="optum-logo">
                  <img src="../../../../assets/img/optum.svg" class="" alt="Optum" width="100" />
                </span>
                <span class="pl-3">Provider Attestation</span>
              </div>
            </div>
            <div class="box-body">
              <h5 class="text-optum-color-dark text-bold pl-3 pr-3">Registration</h5>
              @if (!isOproFlow) {
                <p class="pl-3 pr-3">
                  To help us verify you, please enter the tax identification number and one of the individual provider NPIs you need to attest for. You will be registered for this NPI. If you need to attest for additional NPIs, an option to add them will be provided later in this registration process. Do <b>NOT</b> use your group NPI for this verification step.
                </p>
              }
              @if (isOproFlow) {
                <p class="pl-3 pr-3">
                  Your TIN and NPI have been automatically populated. Click "Verify" to continue.
                </p>
              }
              @if (formGroup) {
                <form [formGroup]="formGroup" class="pl-3 pr-3" [keyBoardEventHandler]="keyHandlers">
                  @if (error) {
                    <div class="alert alert-danger mt-2 mb-2 pl-3 pr-3">
                      {{ errorMessage }}
                    </div>
                  }
                  <div class="form-group"
                    [ngClass]="{'has-error': formGroup.controls['txtTIN'].touched && formGroup.controls['txtTIN'].errors}">
                    <label>Group TIN</label>
                    <input type="text"  class="form-control form-rounded"  placeholder=""  formControlName="txtTIN"
                      (keypress)="keyPressValidation($event)"/>
                    </div>
                    <div class="form-group"
                      [ngClass]="{'has-error': formGroup.controls['txtNPI'].touched && formGroup.controls['txtNPI'].errors}">
                      <label>Individual Provider NPI</label>
                      <input type="text" class="form-control form-rounded" placeholder="" formControlName="txtNPI"/>
                    </div>
                    <div class="text-center pt-3 pb-3">
                      <button type="button" (click)="verify()" class="btn btn-primary rounded-pill">
                        <span class="pl-3 pr-3">
                          <span><i class="fa fa-check"></i> Verify</span>
                        </span>
                      </button>
                    </div>
                  </form>
                }
              </div>
              <div class="box-footer text-center">
                <span>{{copyright}}</span>
              </div>
            </div>
          </div>
        }
        @if (step=='previous' && !isOproFlow) {
          <div class="mt-3 mb-2">
            <div class="box box-default bg-white">
              <div class="box-header">
                <div class="text-center pt-4 pb-4">
                  <span class="optum-logo">
                    <img src="../../../../assets/img/optum.svg" class="" alt="Optum" width="100" />
                  </span>
                  <span class="pl-3">Provider Attestation</span>
                </div>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="custom-control">
                      <h5 class="text-optum-color-dark text-bold">Registration</h5>
                      <p>
                        Welcome back, we see you previously registered for the following NPIs. Would you like to add or change the NPIs you are registering for this attestation period? If you select No, you will <b>NOT</b> be able to add additional NPIs later.
                      </p>
                      <div class="col-xs-12 col-lg-8 border form-control form-rounded mt-1 mb-3 p-2">
                        <div class="custom-control custom-radio">
                          <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input"
                            [(ngModel)]="registerSameDetails" [value]="false">
                            <label class="custom-control-label" for="customRadio1"><b>Yes</b>, allow me to change my NPIs.</label>
                          </div>
                        </div>
                        <div class="col-xs-12 col-lg-8 border form-control form-rounded mt-3 mb-3 p-2">
                          <div class="custom-control custom-radio">
                            <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input"
                              [(ngModel)]="registerSameDetails" [value]="true">
                              <label class="custom-control-label" for="customRadio2"><b>No</b>, register me as shown below:</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-0 ml-2">
                      <div class="col-md-11 mb-0 ml-1">
                        <div class="col-md-3 pl-0 optum-border-bottom"><span class="labelHeader">Providers</span></div>
                        <div class="col"></div>
                      </div>
                    </div>
                    <div class="row ml-2 mr-2">
                      <div class="col-md-12">
                        <ngx-datatable #providerHistorytable class="bootstrap table table-striped"
                          [columns]="providerHistoryColumns" [columnMode]="columnMode.force" [headerHeight]="50"
                          [rowHeight]="50" [rows]="providerHistoryData" [scrollbarV]="true" style="height: 300px;">
                          <ngx-datatable-column name="Name" prop="fullName" [sortable]=false></ngx-datatable-column>
                          <ngx-datatable-column name="NPI" prop="npi" [sortable]=false></ngx-datatable-column>
                          <ngx-datatable-column name="Organization" prop="vendorName" [sortable]=false></ngx-datatable-column>
                          <ngx-datatable-column name="TIN" prop="tin" [sortable]=false></ngx-datatable-column>
                        </ngx-datatable>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 pt-3 pb-3">
                        <button type="button" (click)="sameDetails()"
                        class="btn btn-primary rounded-pill pull-right">Continue</button>
                      </div>
                    </div>
                  </div>
                  <div class="box-footer text-center">
                    <span>{{copyright}}</span>
                  </div>
                </div>
              </div>
            }
            @if (step=='role') {
              <div class="mt-3 mb-2">
                <div class="box box-default bg-white">
                  <div class="box-header">
                    <div class="text-center pt-4 pb-4">
                      <span class="optum-logo">
                        <img src="../../../../assets/img/optum.svg" class="" alt="Optum" width="100" />
                      </span>
                      <span class="pl-3">Provider Attestation</span>
                    </div>
                  </div>
                  <div class="box-body">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="custom-control">
                          <h5 class="text-optum-color-dark text-bold">Select your role</h5>
                          <p>
                            <b>Administrative</b> users have the ability to attest for multiple NPIs under a single tax ID.  The <b>Provider</b> role allows a user to attest for a single individual provider NPI across multiple tax IDs.
                          </p>
                          @if (isOproFlow) {
                            <p class="text-optum-color-dark">
                              <i class="fa fa-info-circle"></i> Configured in your Optum Pro settings
                            </p>
                          }
                          <div class="col-xs-12 col-lg-10 border form-control form-rounded mt-1 mb-3 p-2"
                       [ngClass]="{
                         'bg-light': isOproFlow, 
                         'border-optum': isOproFlow && userRole === 'administrative',
                         'bg-optum-light': isOproFlow && userRole === 'administrative'
                       }">
                            <div class="custom-control custom-radio">
                              <input type="radio" id="customRadio3" name="customRadioRole" class="custom-control-input"
                                [(ngModel)]="userRole" value="administrative" [disabled]="isOproFlow">
                                <label class="custom-control-label text-nowrap" for="customRadio3">
                                  <span [ngClass]="{'text-optum-selected': isOproFlow && userRole === 'administrative'}">
                                    <b>Administrative</b>: single TIN, one or more NPIs.
                                  </span>
                                  @if (isOproFlow && userRole === 'administrative') {
                                    <i class="fa text-optum-color-dark ml-2"></i>
                                  }
                                </label>
                              </div>
                            </div>
                            <div class="col-xs-12 col-lg-10 border form-control form-rounded mt-1 mb-3 p-2"
                       [ngClass]="{
                         'bg-light': isOproFlow, 
                         'border-optum': isOproFlow && userRole === 'provider',
                         'bg-optum-light': isOproFlow && userRole === 'provider'
                       }">
                              <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio4" name="customRadioRole" class="custom-control-input"
                                  [(ngModel)]="userRole" value="provider" [disabled]="isOproFlow">
                                  <label class="custom-control-label text-nowrap" for="customRadio4">
                                    <span [ngClass]="{'text-optum-selected': isOproFlow && userRole === 'provider'}">
                                      <b>Provider</b>: single NPI, one or more TINs.
                                    </span>
                                    @if (isOproFlow && userRole === 'provider') {
                                      <i class="fa fa-check-circle text-optum-color-dark ml-2"></i>
                                    }
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12 pt-3 pb-3 text-center">
                            @if (hideRoleBack==false) {
                              <button type="button" (click)="roleSelect('back',false)"
                                class="btn btn-secondary-optum rounded-pill mr-1"><span class="pl-2 pr-2">Back</span></button>
                              }
                              <button type="button" (click)="roleSelect('next',false)"
                              class="btn btn-primary rounded-pill ml-1">Continue</button>
                            </div>
                          </div>
                        </div>
                        <div class="box-footer text-center">
                          <span>{{copyright}}</span>
                        </div>
                      </div>
                    </div>
                  }
                  @if (step=='select') {
                    <div class="mt-3 mb-2">
                      <div class="box box-default bg-white">
                        <div class="box-header">
                          <div class="text-center pt-4 pb-4">
                            <span class="optum-logo">
                              <img src="../../../../assets/img/optum.svg" class="" alt="Optum" width="100" />
                            </span>
                            <span class="pl-3">Provider Attestation</span>
                          </div>
                        </div>
                        <div class="box-body">
                          <div class="row">
                            <div class="col-12 text-center">
                              <h5 class="text-optum-color-dark text-bold">{{verifiedVendorName}}&nbsp;{{verificationTin}}</h5>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 text-center">
                              @if (!isOproFlow) {
                                <p>You have been registered for provider <span
                                class="text-optum-color-dark text-bold">({{verificationNpi}})</span></p>
                              }
                              @if (!isOproFlow) {
                                <p>Optionally, add additional providers below.</p>
                              }
                              @if (isOproFlow) {
                                <p>Add additional providers below.</p>
                              }
                            </div>
                          </div>
                          <div class="row ml-2">
                            <div class="col-11 ml-1">
                              <div class="col-3 pl-0 optum-border-bottom"><span class="pl-0 labelHeader">All&nbsp;Providers</span></div>
                              <div class="col"></div>
                            </div>
                          </div>
                          <div class="row ml-2 pl-3">
                            <div class="col-11">
                              <div class="form-group">
                                <div class="pull-left">
                                  <label class="form-control-name pt-2">Total&nbsp;Count:&nbsp;{{providerSelectData.length}}</label>
                                </div>
                                <div class="pull-right">
                                  <div class="input-group">
                                    <input type="text" class="form-control form-rounded-1" placeholder="Search ..." (keyup)="updateSelectFilter($event)" />
                                    <div class="input-group-append">
                                      <span class="input-group-text form-rounded-1 bg-white"><i class="fa fa-search text-optum-color-orange"></i></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row ml-2 mr-2">
                            <div class="col-12 ">
                              <ngx-datatable #selecttable class="bootstrap table table-striped" [columns]="selectColumns"
                                [columnMode]="columnMode.force" [headerHeight]="50" [rowHeight]="50" [rows]="providerSelectData"
                                [selected]="selected" [selectionType]="selection" (select)='onSelect($event)' [scrollbarV]="true"
                                style="height: 300px;">
                                <ngx-datatable-column [width]="40" [sortable]="false" [draggable]="false" [resizeable]="false"
                                  [canAutoResize]="false" [headerCheckboxable]="true" [checkboxable]="true" headerClass="text-center"
                                  cellClass="text-center">
                                </ngx-datatable-column>
                                <ngx-datatable-column name="Name" prop="fullName" [sortable]=false></ngx-datatable-column>
                                <ngx-datatable-column name="NPI" prop="npi" [sortable]=false></ngx-datatable-column>
                              </ngx-datatable>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 pt-3 pb-3 text-center">
                              @if (hideSelectBack==false) {
                                <button type="button" (click)="providerSelect('back')"
                                  class="btn btn-secondary-optum rounded-pill mr-1"><span class="pl-2 pr-2">Back</span></button>
                                }
                                <button type="button" (click)="providerSelect('next')"
                                class="btn btn-primary rounded-pill ml-1">Continue</button>
                              </div>
                            </div>
                          </div>
                          <div class="box-footer text-center">
                            <span>{{copyright}}</span>
                          </div>
                        </div>
                      </div>
                    }
                    @if (step=='confirm') {
                      <div class="mt-3 mb-2">
                        <div class="box box-default bg-white">
                          <div class="box-header">
                            <div class="text-center pt-4 pb-4">
                              <span class="optum-logo">
                                <img src="../../../../assets/img/optum.svg" class="" alt="Optum" width="100" />
                              </span>
                              <span class="pl-3">Provider Attestation</span>
                            </div>
                          </div>
                          <div class="box-body">
                            <div class="row">
                              <div class="col-md-12 text-center">
                                <h5 class="text-optum-color-dark text-bold">{{verifiedVendorName}}&nbsp;{{verificationTin}}</h5>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12 text-center">
                                @if (!isOproFlow) {
                                  <p>You have been registered for provider <span
                                  class="text-optum-color-dark text-bold">{{verificationNpi}}</span></p>
                                }
                                <p>Confirm your selection below.</p>
                              </div>
                            </div>
                            <div class="row mb-0 ml-2">
                              <div class="col-3"><span class="text-optum-color-dark text-bold">All&nbsp;Providers</span></div>
                              <div class="col-4 text-left">
                                <div class="pl-0 pb-2 optum-border-bottom">
                                  <span class="text-optum-color-dark text-bold">Selected&nbsp;Providers</span>
                                </div>
                              </div>
                              <div class="col"></div>
                            </div>
                            <div class="row ml-2 mr-2">
                              <div class="col-md-12 ">
                                <ngx-datatable #confirmtable class="bootstrap table table-striped" [columns]="confirmColumns"
                                  [columnMode]="columnMode.force" [headerHeight]="50" [rowHeight]="50" [rows]="providerConfirmData"
                                  [selected]="selected" [selectionType]="selection" (select)='onSelect($event)' [scrollbarV]="true"
                                  style="height: 300px;">
                                  <ngx-datatable-column [width]="40" [sortable]="false" [draggable]="false" [resizeable]="false"
                                    [canAutoResize]="false" [headerCheckboxable]="true" [checkboxable]="true" headerClass="text-center"
                                    cellClass="text-center">
                                  </ngx-datatable-column>
                                  <ngx-datatable-column name="Name" prop="fullName" [sortable]=false></ngx-datatable-column>
                                  <ngx-datatable-column name="NPI" prop="npi" [sortable]=false></ngx-datatable-column>
                                </ngx-datatable>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12 pt-3 pb-3 text-center">
                                <button type="button" (click)="providerConfirm('back')"
                                  class="btn btn-secondary-optum rounded-pill mr-1"><span class="pl-2 pr-2">Back</span></button>
                                  <button type="button" (click)="providerConfirm('next')"
                                  class="btn btn-primary rounded-pill ml-1">Confirm</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="col-xs-1 col-md-3"></div>
                  </div>
                </div>

                <!-- OPRO Additional TINs Modal -->
                <div class="modal fade" id="oproAdditionalTinsModal" #oproModal tabindex="-1" role="dialog"
                  aria-labelledby="oproAdditionalTinsModalLabel" aria-hidden="true" (click)="onModalBackdropClick($event)">
                  <div class="modal-dialog modal-lg" role="document" (click)="$event.stopPropagation()">
                    <div class="modal-content">
                      <div class="modal-header bg-white optum-border-bottom">
                        <h5 class="modal-title text-optum-color-dark text-bold" id="oproAdditionalTinsModalLabel">
                          <i class="fa fa-building"></i>
                          Additional Organizations
                        </h5>
                        <button type="button" class="close text-white" (click)="cancelOproModal()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="alert">
                          <i class="fa fa-info-circle text-optum-color-dark"></i>
                          The following additional organizations are available for registration. Please select which ones you would like to register for or remove from your profile.
                        </div>

                        <div>
                          <table class="table">
                            <thead>
                              <tr>
                                <th class="text-optum-color-dark">Organization</th>
                                <th class="text-optum-color-dark text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (tin of additionalTinsList; track tin; let i = $index) {
                                <tr>
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <div>
                                        <strong>{{tin.name}}</strong><br>
                                        <small class="text-muted">TIN: {{tin.tin}}</small>
                                        <!-- Hidden field for ProviderAttestationVendorId -->
                                        <input type="hidden" [value]="tin.providerAttestationVendorId" />
                                      </div>
                                      <span class="ml-auto badge"
                          [ngClass]="{
                            'badge-warning': tin.status === 'pending',
                            'badge-success': tin.status === 'registered'
                          }">
                                        {{tin.status | titlecase}}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="text-center align-middle">
                                    <div class="btn-group" role="group">
                                      <button type="button"
                                        class="btn btn-sm rounded-pill pl-3 pr-3"
                            [ngClass]="{
                              'btn-primary': tin.status !== 'registered',
                              'btn-outline-primary': tin.status === 'registered'
                            }"
                                        [disabled]="tin.status === 'registered'"
                                        (click)="registerAdditionalTin(tin)">
                                        <i class="fa fa-check"></i> Register
                                      </button>
                                      <button type="button"
                                        class="btn btn-sm btn-secondary-optum rounded-pill ml-2 pl-3 pr-3"
                                        (click)="removeAdditionalTin(tin)">
                                        <i class="fa fa-times"></i> Remove
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary-optum rounded-pill pl-3 pr-3" (click)="cancelOproModal()">
                          <i class="fa fa-times"></i> Cancel
                        </button>
                        <button type="button" class="btn btn-primary rounded-pill pl-3 pr-3 ml-2" (click)="saveAdditionalTins()">
                          <i class="fa fa-save"></i> Save and Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </div>